import { render, staticRenderFns } from "./uz.vue?vue&type=template&id=70e6a8d4&scoped=true&"
import script from "./uz.vue?vue&type=script&lang=ts&"
export * from "./uz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6a8d4",
  null
  
)

export default component.exports